import React, { Component } from 'react';
import styles from './index.less';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ActionType, InsertStateType } from '../../../editor/src/js/constants/common-action-type';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import sprite from './sprite.css';
import classNames from 'classnames';
import { LineShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    EventCodeType,
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
    TDWVer3Type,
    TDWVer4Type,
} from '../../../../slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { transaction } from '@src/slide/domain/slide-app';
import { FIXED_KEYS_DOUBLE } from '@src/framework/workbench/schema/constant';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { isPictureModel, isShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';

interface ItemIconProps {
    groupid: string;
    type: string;
    width: number;
    height: number;
    title: string;
    bg?: string;
    wbPath?: string;
    isFromSingleBar?: boolean;
    isFromInsertPanel?: boolean;
    cropPicker?: boolean;
    hideMenu?: () => void;
    hideToolBar?: () => void;
}

interface ItemIconState {
    tooltipVisible: boolean;
}

/**
 * shape菜单
 */
export default class ItemIcon extends Component<ItemIconProps, ItemIconState> {
    state = {
        tooltipVisible: false,
    };

    public render() {
        return <Tooltip
            key={`tip-${this.props.type}`}
            title={this.props.title}
            placement={'bottom'}
            zIndex={99999}
            visible={this.state.tooltipVisible}
            // 解决【裁剪为形状列表弹窗】出现 tooltip 时，鼠标 hover 到 tooltip 上导致弹窗消失的问题，鼠标快速滑动会导致闪烁
            // 排查了下原因应该是 dui 两个月前这次改动（https://git.woa.com/tencent-doc/dui/commit/9a8ec6c94861635b35062e7c03288dbaccd2021c）
            // 给 tooltip 的消失加上了延迟导致
            containerStyle={{ pointerEvents: 'none' }}
            overlayStyle={{ zIndex: 99999 }}>
            <div id={`${this.props.type}`} key={`${this.props.type}`} className={styles.sub}
                onClick={this.onShapeItemClick()}
                onMouseLeave={this.handleMouseLeave}
                onMouseEnter={this.handleMouseEnter}>
                <span className={classNames(sprite.icon, sprite[`icon-${this.props.type}`])}/>
            </div>
        </Tooltip>;
    }
    private insertShapeElement = () => {
        this.tdwReport();
        if (!this.getSelectionService().currentSlide) return; // sanzhiyang

        // 清空元素选中，避免时序错误
        this.getSelectionService()?.selectedElements.clear();

        if (this.props.groupid === 'connectorLine') {
            if (this.props.type === LineShapeType.ArbitraryShape) {
                if (!this.getEditingStateManager().insertState
                    || InsertStateType.ARBITRARYSHAPE !== this.getEditingStateManager().insertState.type) {
                    this.getEditingStateManager().insertState = {
                        type: InsertStateType.ARBITRARYSHAPE,
                        data: null,
                    };
                }
            } else if (this.props.type === LineShapeType.FreeCurve) {
                if (!this.getEditingStateManager().insertState
                    || InsertStateType.FREECURVE !== this.getEditingStateManager().insertState.type) {
                    this.getEditingStateManager().insertState = {
                        type: InsertStateType.FREECURVE,
                        data: null,
                    };
                }
            } else {
                this.getEditingStateManager().insertState = {
                    type: InsertStateType.CONNECTOR,
                    data: {
                        type: this.props.type,
                        width: this.props.width,
                        height: this.props.height,
                        title: this.props.title,
                        headEndType: 'triangle',
                        tailEndType: 'triangle',
                    },
                };
            }
        } else {
            this.getEditingStateManager().insertState = {
                type: InsertStateType.SHAPE,
                data: {
                    type: this.props.type,
                    width: this.props.width,
                    height: this.props.height,
                    title: this.props.title,
                    bg: this.props.bg,
                },
            };
        }
        this.getSelectionService().lastMouseDownRegion = RegionType.EDITOR;
        this.getSelectionService().selectedSlides.clear();
    };

    private tdwReport() {
        const reportInfo = {
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_INSERT_TAB,
            action: TDWActionType.SHAPES,
            eventcode: EventCodeType.DOC_PPT_TOOLBAR_INSERT_TAB_SHAPES,
        };
        if (this.props.wbPath?.includes(ActionType.SINGLE_TOOLBAR_MENU)) {
            tdw({
                ...reportInfo,
                ver3: 1,
                ver5: this.props.type, // 形状
            });
        } else if (this.props.wbPath?.includes(FIXED_KEYS_DOUBLE.TOOLBAR_INSERT)) {
            tdw({
                ...reportInfo,
                ver3: 2,
                ver5: this.props.type, // 形状
            });
        } else {
            const { isFromInsertPanel } = this.props;
            let module = TDWModuleType.PC_TOOLBAR;
            if (isFromInsertPanel) {
                module = TDWModuleType.PC_TOOLBAR_INSERT;
            }
            let ver3 = TDWVer3Type.DOUBLE_TOOLBAR;
            if (this.props.isFromSingleBar) {
                ver3 = TDWVer3Type.SINGLE_TOOLBAR;
            }
            // 上报
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module,
                action: TDWActionType.SHAPES,
                ver3,
                ver4: TDWVer4Type.TOOLBAR_NORMAL_DISPLAY,
                ver5: this.props.type, // 形状
            });
        }
    }

    /**
     * 裁剪为形状
     */
    private cropElement = () => {
        const selectedModel = this.getSelectModel();
        const type = selectedModel?.type;
        if (type === UIModelType.SHAPE || type === UIModelType.IMAGE) {
            (selectedModel as IShapeModel | IPictureModel)?.getImageCrop().cropWithShape?.(this.props.type);
        } else if (type === UIModelType.GROUP || type === UIModelType.MULTIPLY) {
            const selectedModels = getAllChildModels(selectedModel as IGroupModel | IMultiplyModel);
            const images = selectedModels.filter(model => this.isCropable(model)) as Array<IShapeModel | IPictureModel>;
            if (images.length) {
                transaction(() => {
                    images.forEach((image) => {
                        image.getImageCrop?.().cropWithShape(this.props.type);
                    });
                });
            }
        }
    };

    private isCropable = (model: IElementBaseModel) => {
        if (model.isAttachment()) return false;
        if (isPictureModel(model)) {
            return model.isImage();
        } if (isShapeModel(model)) {
            return !model.isTextMath;
        }
        return false;
    };

    private onShapeItemClick = () =>  // shape item 点击事件
        () => {
            if (this.props.cropPicker) {
                this.cropElement();
            } else {
                this.insertShapeElement();
            }
            if (this.props.hideMenu) {
                this.props.hideMenu();
            }
            if (this.props.hideToolBar) {
                this.props.hideToolBar();
            }
        }
        ;

    private handleMouseEnter = () => {
        this.setState({ tooltipVisible: true });
    };

    private handleMouseLeave = () => {
        this.setState({ tooltipVisible: false });
    };

    private getSelectModel() {
        return this.getSelectionService().getSelectedModel();
    }
    private getSelectionService = () => this.getAppService().viewableServiceLayer?.selectionService;

    private getEditingStateManager = () => this.getAppService().viewableServiceLayer.editingStateManager;

    private getAppService = () => AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
}
